(function() {
  "use strict";

  if ($("#text-editor").length > 0) {
    var toolbarOptions = [
      [{ size: ["small", false, "large"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],
      ["link"]
    ];
    var quill = new Quill("#text-editor", {
      theme: "snow",
      placeholder: "Digite uma descrição",
      modules: {
        toolbar: toolbarOptions
      }
    });
    quill.on("text-change", function() {
      $("#text-handle").val(quill.root.innerHTML);
    });
  }
})();
